import { MoreLikeThisUI } from "./MoreLikeThisUI";
import { StandardProps } from "../componentMap";

export const MoreLikeThis = ({
  product,
  runtimeConfig,
}: Pick<StandardProps, "product" | "runtimeConfig">) => {
  const { esiBasepath } = runtimeConfig;

  return (
    <MoreLikeThisUI
      productId={product.aliases.pimProductId}
      esiBasepath={esiBasepath}
    />
  );
};
